import React, {useState} from 'react'
import gql from 'graphql-tag'
import {useQuery} from '@apollo/react-hooks'
import {AutoComplete} from 'antd'

const brokerSearchQuery = gql`
  query BrokerSearch($q: String!) {
    viewer {
      id
      broker {
        id
        brokerSearch(q: $q, first: 100) {
          edges {
            node {
              id
              name
              email
            }
          }
        }
      }
    }
  }
`

const THROTTLE_DELAY = 1000

let searchThrottle

const BrokerSearch = ({onChange, initalValue}) => {
  const [searchString, setSearchString] = useState('')
  const defaultValue = initalValue ? `${initalValue.name} (${initalValue.email})` : null
  const {loading, data} = useQuery(brokerSearchQuery, {variables: {q: searchString}})

  function performSearch(query) {
    clearTimeout(searchThrottle)
    searchThrottle = setTimeout(() => setSearchString(query), THROTTLE_DELAY)
  }

  let results = []
  if (!loading) {
    results = data.viewer.broker.brokerSearch.edges.map(({node}) => (
      {key: node.id, value: `${node.name} (${node.email})`}
    ))
  }

  return (
    <AutoComplete
      defaultValue={defaultValue}
      options={results}
      onSelect={(value, option) => onChange(option.key)}
      onSearch={performSearch}
    />
  )
}

export default BrokerSearch
